// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict, List } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    spotKlinePublicGetPublicJson (params?: {}): Promise<Dict>;
    spotKlinePublicGetPublicCurrencyJson (params?: {}): Promise<Dict>;
    spotV1PublicGetPing (params?: {}): Promise<Dict>;
    spotV1PublicGetTime (params?: {}): Promise<Dict>;
    spotV1PublicGetExchangeInfo (params?: {}): Promise<Dict>;
    spotV1PublicGetDepth (params?: {}): Promise<Dict>;
    spotV1PublicGetTrades (params?: {}): Promise<List>;
    spotV1PublicGetHistoricalTrades (params?: {}): Promise<List>;
    spotV1PublicGetAggTrades (params?: {}): Promise<List>;
    spotV1PublicGetTicker24hr (params?: {}): Promise<List>;
    spotV1PublicGetTickerPrice (params?: {}): Promise<Dict>;
    spotV1PublicGetTickerBookTicker (params?: {}): Promise<Dict>;
    spotV1PublicGetMarketKline (params?: {}): Promise<Dict>;
    spotV1PrivateGetOrder (params?: {}): Promise<Dict>;
    spotV1PrivateGetOpenOrders (params?: {}): Promise<Dict>;
    spotV1PrivateGetAllOrders (params?: {}): Promise<List>;
    spotV1PrivateGetAccount (params?: {}): Promise<Dict>;
    spotV1PrivateGetMyTrades (params?: {}): Promise<List>;
    spotV1PrivateGetEtfNetValueSymbol (params?: {}): Promise<Dict>;
    spotV1PrivateGetWithdrawHistory (params?: {}): Promise<Dict>;
    spotV1PrivateGetDepositHistory (params?: {}): Promise<Dict>;
    spotV1PrivatePostOrder (params?: {}): Promise<Dict>;
    spotV1PrivatePostWithdrawCommit (params?: {}): Promise<Dict>;
    spotV1PrivateDeleteOrder (params?: {}): Promise<Dict>;
    spotV2PrivateGetMyTrades (params?: {}): Promise<Dict>;
    fapiV1PublicGetPing (params?: {}): Promise<Dict>;
    fapiV1PublicGetTime (params?: {}): Promise<Dict>;
    fapiV1PublicGetContracts (params?: {}): Promise<List>;
    fapiV1PublicGetDepth (params?: {}): Promise<Dict>;
    fapiV1PublicGetTicker (params?: {}): Promise<Dict | List>;
    fapiV1PublicGetKlines (params?: {}): Promise<List>;
    fapiV2PrivateGetMyTrades (params?: {}): Promise<Dict>;
    fapiV2PrivateGetOpenOrders (params?: {}): Promise<Dict>;
    fapiV2PrivateGetOrder (params?: {}): Promise<Dict>;
    fapiV2PrivateGetAccount (params?: {}): Promise<Dict>;
    fapiV2PrivateGetLeverageBracket (params?: {}): Promise<Dict>;
    fapiV2PrivateGetCommissionRate (params?: {}): Promise<Dict>;
    fapiV2PrivateGetFuturesTransferHistory (params?: {}): Promise<Dict>;
    fapiV2PrivateGetForceOrdersHistory (params?: {}): Promise<Dict>;
    fapiV2PrivatePostPositionMargin (params?: {}): Promise<Dict>;
    fapiV2PrivatePostLevelEdit (params?: {}): Promise<Dict>;
    fapiV2PrivatePostCancel (params?: {}): Promise<Dict>;
    fapiV2PrivatePostOrder (params?: {}): Promise<Dict>;
    fapiV2PrivatePostAllOpenOrders (params?: {}): Promise<Dict>;
    fapiV2PrivatePostFuturesTransfer (params?: {}): Promise<Dict>;
    dapiV1PublicGetPing (params?: {}): Promise<Dict>;
    dapiV1PublicGetTime (params?: {}): Promise<Dict>;
    dapiV1PublicGetContracts (params?: {}): Promise<List>;
    dapiV1PublicGetDepth (params?: {}): Promise<Dict>;
    dapiV1PublicGetTicker (params?: {}): Promise<List>;
    dapiV1PublicGetKlines (params?: {}): Promise<Dict>;
    dapiV2PrivateGetMyTrades (params?: {}): Promise<Dict>;
    dapiV2PrivateGetOpenOrders (params?: {}): Promise<Dict>;
    dapiV2PrivateGetOrder (params?: {}): Promise<Dict>;
    dapiV2PrivateGetAccount (params?: {}): Promise<Dict>;
    dapiV2PrivateGetLeverageBracket (params?: {}): Promise<Dict>;
    dapiV2PrivateGetCommissionRate (params?: {}): Promise<Dict>;
    dapiV2PrivateGetFuturesTransferHistory (params?: {}): Promise<Dict>;
    dapiV2PrivateGetForceOrdersHistory (params?: {}): Promise<Dict>;
    dapiV2PrivatePostPositionMargin (params?: {}): Promise<Dict>;
    dapiV2PrivatePostLevelEdit (params?: {}): Promise<Dict>;
    dapiV2PrivatePostCancel (params?: {}): Promise<Dict>;
    dapiV2PrivatePostOrder (params?: {}): Promise<Dict>;
    dapiV2PrivatePostAllOpenOrders (params?: {}): Promise<Dict>;
    dapiV2PrivatePostFuturesTransfer (params?: {}): Promise<Dict>;
    openV1PrivatePostPoseidonApiV1ListenKey (params?: {}): Promise<Dict>;
    openV1PrivatePutPoseidonApiV1ListenKeyListenKey (params?: {}): Promise<Dict>;
    openV1PrivateDeletePoseidonApiV1ListenKeyListenKey (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
